import React from "react";

import { cn } from "@/lib/helpers/cn";
import { Heading2 } from "@/ui2/atoms/Heading";
import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";

export function SingleReport(props) {
  const { badges, customButton, id, isEnabled, metaData, subTitle, title } = props;

  return (
    <li key={id}>
      <DashboardCard2
        className={cn(
          "tw:grid tw:items-center tw:max-md:gap-2 tw:md:gap-4",
          "tw:max-md:grid-flow-row tw:max-md:justify-start",
          "tw:md:grid-cols-[2fr_1fr_150px_40px]",
          "tw:min-h-20.25 tw:justify-center tw:px-6! tw:py-5!",
        )}
        rawChildren
      >
        <div className="tw:flex tw:flex-col">
          <p className="tw:flex tw:flex-col tw:items-start">
            <Heading2 as="b" className={cn(!isEnabled && "tw:text-text-quinary")} size={2}>
              {title}
            </Heading2>

            <span className="body-md">{subTitle}</span>
          </p>
        </div>

        <div className="tw:flex tw:flex-col tw:gap-2 tw:pr-5 tw:max-md:items-start tw:md:items-end">
          {badges}
        </div>

        {metaData}

        <div className="tw:flex tw:md:justify-end">{customButton}</div>
      </DashboardCard2>
    </li>
  );
}
